// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"c7a996cd","492":"6dcb4bc7"}[chunkId] + ".chunk.css";
};